<template>
  <div v-if="isCheckoutBusy" class="loading-page">
    <Spinner />
  </div>
</template>

<script>
import Spinner from '~/../common/components/Loading/Spinner.vue'
export default {
  name: 'CheckoutLoading',
  components: { Spinner },
  computed: {
    isCheckoutBusy() {
      return this.$store.getters.isWorkGroupBusy('checkout')
    },
  },
}
</script>

<style scoped></style>
